import React, { useEffect, useState } from "react";
import { Measurement } from "../inputs";

// Usage: <DimensionsInput name="smoothed" defaultValue={this.state.smoothed} updateOnChange={this.updateField} />

export const DimensionsInput = (props) => {
    const [state, setState] = useState({
        itemHeight: props.defaultValue ? props.defaultValue.itemHeight : "",
        itemWidth: props.defaultValue ? props.defaultValue.itemWidth : "",
        itemDepth: props.defaultValue ? props.defaultValue.itemDepth : "",
    });

    useEffect(() => {
        setState({
            itemHeight: props.defaultValue ? props.defaultValue.itemHeight : "",
            itemWidth: props.defaultValue ? props.defaultValue.itemWidth : "",
            itemDepth: props.defaultValue ? props.defaultValue.itemDepth : "",
        });
    }, []);

    const updateState = (name, value) => {
        props.updateOnChange(props.name, {
            itemHeight: state.itemHeight || null,
            itemWidth: state.itemWidth || null,
            itemDepth: state.itemDepth || null,
            [name]: value,
        });
    };

    return (
        <div className="dimensions-input-group">
            <Measurement label="Height" name="itemHeight" defaultValue={state.itemHeight} updateOnChange={updateState} filter={["length"]} />
            <Measurement label="Width" name="itemWidth" defaultValue={state.itemWidth} updateOnChange={updateState} filter={["length"]} />
            <Measurement label="Depth" name="itemDepth" defaultValue={state.itemDepth} updateOnChange={updateState} filter={["length"]} />
        </div>
    );
};
